import React, { useEffect, useState } from 'react'
import { API } from '../../../api/Api';

const VisualizerDropDown = ({ onTypeSelect, className, value }) => {

    const [type, setType] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchCategory = async () => {
        // const url = API_ROUTES.GET_ACTIVITY_LIST;
        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = '/visualizer/getvisualizermasterlist';
        const url = `${baseURl}${apiPath}`;
        const requestBody = { type: "type" };

        try {
            const token = localStorage.getItem('token');
            const response = await API(url, requestBody, token);

            if (response) {
                setType(response.Data);
            }
        } catch (error) {
            setError('Error fetching category');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCategory();
    }, []);

    if (loading) return <p className='text-sm my-4 mx-2'>Loading type...</p>;
    if (error) return <p>{error}</p>;
    return (
        <div className="mb-4">
            <select
                value={value}
                onChange={(e) => onTypeSelect(e.target.value)}
                // className={`${className} border rounded px-4 py-2 focus:outline-none focus:ring focus:ring-blue-300 transition`}
                className={`${className} block w-full py-2 px-4 text-gray-900 bg-white rounded-lg  focus:outline-none`}

            >
                <option value="">Select Type</option>
                {type.map((type) => (
                    <option key={type.id} value={type.id}>
                        {type.name}
                    </option>
                ))}
            </select>
        </div>
    )
}

export default VisualizerDropDown